import { UserTOS } from "../components/UserTOS/UserTOS";
import { InfoPageLayout } from "../Layouts/InfoPageLayout";

export function UserAgreement() {
    return (
        <InfoPageLayout>
            <div className="section-box p-4 m-20 gap-4 grow">
                <div className="text-xl flex flex-row">
                    <div className="flex flex-row grow">
                        <h3 className="section-title">Terms and Condition</h3>
                    </div>
                </div>
                <div className="max-h-[750px] overflow-auto">
                    <UserTOS />
                </div>
            </div>
           
        </InfoPageLayout>
    )
}